import { FC, Suspense, lazy, useEffect } from "react";
import { Navigate, Route, Routes, useNavigate } from "react-router-dom";
import TopBarProgress from "react-topbar-progress-indicator";
import { getCSSVariableValue } from "../../_metronic/assets/ts/_utils";
import { WithChildren } from "../../_metronic/helpers";
import { MasterLayout } from "../../_metronic/layout/MasterLayout";
import { KEY_LOCALSTORAGE } from "../../app/modules/auth/core/_consts";
import { localStorageItem } from "../../app/modules/utils/LocalStorage";
import EMRPage from "../modules/emr/EMRPage";
import { HomePage } from "../pages/Homepage/HomePage";
import { MenuTestPage } from "../pages/MenuTestPage";
import { DashboardWrapper } from "../pages/dashboard/DashboardWrapper";
import PatientInformation from "../modules/emr/components/tab-emr-detail/components/PatientInformation";
import PatientList from '../modules/patients';
import MedicalRecord from '../modules/medical-records';
import Signature from '../modules/signatures';

const PrivateRoutes = () => {
  const menusEmr =
		localStorageItem.get(KEY_LOCALSTORAGE.ID_TOKEN_DECODE)?.["menus"]?.["oceantech-emr-server"] ||
		[];
	const menusInpatient =
		localStorageItem.get(KEY_LOCALSTORAGE.ID_TOKEN_DECODE)?.["menus"]?.[
			"oceantech-emr-inpatient-server"
		] || [];
	const menusOutpatient =
		localStorageItem.get(KEY_LOCALSTORAGE.ID_TOKEN_DECODE)?.["menus"]?.[
			"oceantech-emr-outpatient-server"
		] || [];
  const menusByPermission = [...menusEmr, ...menusInpatient, ...menusOutpatient];
  const WizardsPage = lazy(() => import("../modules/wizards/WizardsPage"));
  const navigate = useNavigate();

  useEffect(() => {
    if (!menusByPermission?.length) {
      navigate("/error/403");
    } else {
      // navigate(`${menusByPermission?.[0]?.uri}`);
    }
  }, [menusByPermission?.length])
  return (
    <Routes>
      <Route index element={<Navigate to={`/patients`} />} />
      <Route path="/*" element={<Navigate to={`/patients`} />} />
      <Route path="home" element={<HomePage />} />
      <Route element={<MasterLayout />}>
        {/* Redirect to Dashboard after success login/registartion */}
        <Route path="auth/*" element={<Navigate to="/home" />} />
        {/* Pages */}
        <Route path="dashboard" element={<DashboardWrapper />} />
        <Route path="menu-test" element={<MenuTestPage />} />
        {/* <Route path="benh-an-dien-tu" element={<EMRPage />} /> */}
        {/* <Route path="emr/patient/:id" element={<PatientInformation />} /> */}
        <Route path="patients" element={<PatientList />} />
        <Route path="signatures" element={<Signature />} />
        <Route path="medical-records" element={<MedicalRecord />} />

        {/* Lazy Modules */}
        <Route path="crafted/pages/profile/*" element={<SuspensedView></SuspensedView>} />
        <Route
          path="crafted/pages/wizards/*"
          element={
            <SuspensedView>
              <WizardsPage />
            </SuspensedView>
          }
        />
        {/* Page Not Found */}
        <Route path="*" element={<Navigate to="/error/404" />} />
      </Route>
    </Routes>
  );
};

const SuspensedView: FC<WithChildren> = ({ children }) => {
  const baseColor = getCSSVariableValue("--kt-primary");
  TopBarProgress.config({
    barColors: {
      "0": baseColor,
    },
    barThickness: 1,
    shadowBlur: 5,
  });
  return <Suspense fallback={<TopBarProgress />}>{children}</Suspense>;
};

export { PrivateRoutes };

